import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import { Player } from 'shikwasa'
import 'shikwasa/dist/style.css'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faCirclePlay,
	faCirclePause,
} from '@fortawesome/free-regular-svg-icons'

library.add(faCirclePlay, faCirclePause)

@Component({
	components: {
		Loader,
	},
})
export default class Podcasts extends Vue {
	podcasts = [] as Array<any>
	loading = true
	player

	channel = {
		author: '',
		desc: '',
		image: '',
		link: 'https://open.spotify.com/show/3z2k67lnJWq5TbKpMbz2Dg?si=8912bde4e0a44560',
	}

	get selectedPodcast() {
		return this.podcasts.find((podcast) => podcast.selected)
	}

	loadPodcasts() {
		fetch('https://anchor.fm/s/d95ff364/podcast/rss')
			.then((response) => response.text())
			.then((str) =>
				new window.DOMParser().parseFromString(str, 'text/xml'),
			)
			.then((data) => {
				const channelXml = data.querySelector('channel') as any
				this.channel.author =
					channelXml.getElementsByTagName(
						'itunes:author',
					)[0].textContent
				this.channel.desc =
					channelXml.getElementsByTagName(
						'itunes:summary',
					)[0].textContent
				this.channel.image = channelXml
					.getElementsByTagName('itunes:image')[0]
					.getAttribute('href')

				const items = data.querySelectorAll('item')
				for (let x = 0; x < 3; x++) {
					const item = items[x]
					const podcast = {
						id: item.getElementsByTagName('guid')[0].textContent,
						title: item.getElementsByTagName('title')[0]
							.textContent,
						desc: item.getElementsByTagName('description')[0]
							.textContent,
						date: this.formatDate(
							item.getElementsByTagName('pubDate')[0].textContent,
						),
						episode:
							item.getElementsByTagName('itunes:episode')[0]
								.textContent,
						season: item.getElementsByTagName('itunes:season')[0]
							.textContent,
						image: item
							.getElementsByTagName('itunes:image')[0]
							.getAttribute('href'),
						duration:
							item.getElementsByTagName('itunes:duration')[0]
								.textContent,
						link: item.getElementsByTagName('link')[0].textContent,
						audio: {
							url: item
								.getElementsByTagName('enclosure')[0]
								.getAttribute('url'),
							type: item
								.getElementsByTagName('enclosure')[0]
								.getAttribute('type'),
							length: item
								.getElementsByTagName('enclosure')[0]
								.getAttribute('length'),
						},
						playing: false,
						selected: false,
					}

					let [full, hour, min, sec] =
						/(\d{2}):(\d{2}):(\d{2})/.exec(podcast.duration!) || []
					let duration = ''
					duration += parseInt(hour) <= 0 ? '' : hour + 'h '
					duration += parseInt(min) <= 0 ? '' : min + 'm '
					duration += parseInt(sec) <= 0 ? '' : sec + 's'

					podcast.duration = duration

					this.podcasts.push(podcast)
				}

				this.loading = false
				this.buildPlayer()
			})
	}

	async buildPlayer() {
		await this.$nextTick()
		this.player = new Player({
			container: () => document.querySelector('.player'),
			themeColor: '#fa4616',
			audio: {
				title: this.podcasts[0].title,
				artist: this.channel.author,
				cover: this.podcasts[0].image,
				src: this.podcasts[0].audio.url,
			},
		})

		this.podcasts[0].selected = true

		this.player.on('playing', () => {
			this.podcasts.forEach((podcast) => {
				podcast.playing = false
			})
			this.selectedPodcast.playing = true
		})

		this.player.on('pause', () => {
			this.selectedPodcast.playing = false
		})
	}

	playPodcast(clickedPodcast) {
		if (clickedPodcast.id === this.selectedPodcast.id) {
			this.player.play()
			return
		}

		this.podcasts.forEach((podcast) => {
			podcast.selected = false
		})

		clickedPodcast.selected = true
		this.player.update({
			title: clickedPodcast.title,
			artist: this.channel.author,
			cover: clickedPodcast.image,
			src: clickedPodcast.audio.url,
		})

		this.player.play()
	}

	pausePodcast() {
		this.player.pause()
	}

	formatDate(dateString) {
		const d = new Date(dateString)
		return new Intl.DateTimeFormat('pt-BR', {
			day: 'numeric',
			month: 'short',
			year: 'numeric',
		}).format(d)
	}

	mounted() {
		this.loadPodcasts()
	}
}
